import { render, staticRenderFns } from "./first-invite-introduce.vue?vue&type=template&id=490cd482&scoped=true"
var script = {}
import style0 from "./first-invite-introduce.vue?vue&type=style&index=0&id=490cd482&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490cd482",
  null
  
)

export default component.exports